// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2LTE1","overflowing":"ReadFullNote_overflowing__3W6i3"};